import { useLogout } from '../hooks/useLogout';

export const MobileTopBar = () => {
  const logout = useLogout();

  return (
    <header className="md:hidden h-14 shrink-0 flex items-center justify-between px-4 bg-white border-b border-gray-200">
      <span className="font-semibold text-gray-900">Operations</span>
      <button
        onClick={logout}
        className="text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors"
      >
        Logout
      </button>
    </header>
  );
};
